import { render, staticRenderFns } from "./DashboardConventions.vue?vue&type=template&id=2d396898&scoped=true"
import script from "./DashboardConventions.vue?vue&type=script&lang=js"
export * from "./DashboardConventions.vue?vue&type=script&lang=js"
import style0 from "./DashboardConventions.vue?vue&type=style&index=0&id=2d396898&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d396898",
  null
  
)

export default component.exports